import {Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import {
    AiAppEventRendererComponent
} from "../../../../../../../modules/ai/realtime/api/component/aiAppEventRenderer.component";
import {AiRealtimeAppEvent} from "../../../../../../../modules/ai/realtime/api/service/aiRealtime.service";
import {
    MedicalRecordProblemConverter
} from "../../../../../../../modules/medical/medical-record/problem/api/converter/medicalRecordProblem.converter";
import {
    MedicalRecordProblemModel
} from "../../../../../../../modules/medical/medical-record/problem/api/model/medicalRecordProblem.model";
import {ConsultationProblemItemComponent} from "../consultation-problem-item/consultation-problem-item.component";

@Component({
    selector: 'app-problem-ai-event',
    standalone: true,
    imports: [ConsultationProblemItemComponent],
    template: `
    <app-luna-consultation-problem-item
      titleDisplay="title"
      [problem]="problem">
    </app-luna-consultation-problem-item>
  `,
})
export class ConsultationProblemAiEventComponent implements AiAppEventRendererComponent, OnChanges {
    static readonly eventName = 'medicalProblem';
    problem: MedicalRecordProblemModel;

    @Input() event!: AiRealtimeAppEvent;

    constructor(private problemConverter: MedicalRecordProblemConverter) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.problem = this.problemConverter.convert(this.event?.data);
    }
}
